import React, { useState } from 'react';
import styles from './profilebody.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import AddVendorBilling from '../addEditAddress/AddVendorBilling';
import AddVendorShipping from '../addEditAddress/AddVendorShipping';
import AccountSettings from '../../../CustomerDash/Components/profilebody/AccountSettings';

const VendorProfileBody = () => {

    const { id } = useParams()
    const [isAddPopupOpen, setAddPopupOpen] = useState(false);
    const [isAddShipPopupOpen, setAddShipPopupOpen] = useState(false);

    const openAddPopup = () => {
        setAddPopupOpen(true);
    };

    const closeAddPopup = () => {
        setAddPopupOpen(false);
    };

    const openAddShipPopup = () => {
        setAddShipPopupOpen(true);
    };

    const closeAddShipPopup = () => {
        setAddShipPopupOpen(false);
    };
    
    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: "20px", width: "100%" }}>
                <AccountSettings />

                <div className={styles.profilebodyContainer}>
                    <div className={styles.profileheader}>
                        <h2>Change Password</h2>
                    </div>

                    <div className={styles.profilebodyContent}>
                        <div className={styles.profilebodyDetails} style={{ width: '100%' }}>
                            <label className={styles.addCatLabel} style={{ width: '100%' }}>
                                Current Password
                                <div className={styles.logininputContainer}>
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="********"
                                    /*  className={styles.addCatInput} */
                                    />
                                    <FontAwesomeIcon
                                        icon={faEye}
                                        className={styles.loginpasswordIcon}
                                    />
                                </div>
                            </label>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    New Password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type="password"
                                            name="password"
                                            placeholder="********"
                                        /*  className={styles.addCatInput} */
                                        />
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className={styles.loginpasswordIcon}
                                        />
                                    </div>
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Confirm Password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type="password"
                                            name="password"
                                            placeholder="********"
                                        />
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className={styles.loginpasswordIcon}
                                        />
                                    </div>
                                </label>
                            </div>
                            <button className={styles.savechanges}>Change Password</button>

                        </div>
                    </div>
                </div>


                <div className={styles.profilebodyContainer}>
                    <div className={styles.profileheader}>
                        <h2>Billing Address</h2>
                        <button className={styles.savechanges} onClick={openAddPopup}>Add New Addres</button>
                        {isAddPopupOpen && <AddVendorBilling onClose={closeAddPopup} id={id} />}
                    </div>
                    <div className={styles.profilebodyContent}>
                        <div className={styles.emptyAddress}>No billing address has been added yet.</div>
                    </div>

                </div>


                <div className={styles.profilebodyContainer}>
                    <div className={styles.profileheader}>
                        <h2>Shipping Address</h2>
                        <button className={styles.savechanges} onClick={openAddShipPopup}>Add New Addres</button>
                        {isAddShipPopupOpen && <AddVendorShipping onClose={closeAddShipPopup} id={id} />}
                    </div>
                    <div className={styles.profilebodyContent}>
                        <div className={styles.emptyAddress}>No shipping address has been added yet.</div>
                    </div>
                </div>

            </div >
        </>
    );
};

export default VendorProfileBody;
